import Carte_Grise from '@amo/core/assets/images/AMO_Icons/Carte_Grise.svg';
import { Question } from '@amo/core/components/containers';
import { Radio } from '@amo/core/components/forms';
import _ from 'lodash';
import moment from 'moment';
import { Field } from 'redux-form';
import TitulaireMajeur from './TitulaireMajeur/TitulaireMajeur';
import TitulaireMineur from './TitulaireMineur/TitulaireMineur';
import {getTranslation} from "@amo/core/utils/functions.js";

const TitulaireCarteGrise = (props) => {
    const { nextQuestion, data } = props;

    const souscripteurIsMineur = (data) => {
        return (
            moment(_.get(data, 'DemandeTarif[ListePersonnes][0][DateNaissance]'), 'DD/MM/YYYY').add(18, 'years') >=
            moment()
        );
    };

    return (
        <Question asFieldset required icon={Carte_Grise} title={getTranslation("profil.holderRegistrationVehicle.title")}>
            <div className={'row justify-content-center mt-2'}>
                {souscripteurIsMineur(data) ? <TitulaireMineur {...props} /> : <TitulaireMajeur {...props} />}
                <div className={'col-lg-4 col-md-6 col-sm-6 col-6 my-2'}>
                    <Field
                        component={Radio}
                        type={'radio'}
                        name={'titulaireCarteGrise'}
                        value={'autres'}
                        label={getTranslation("profil.holderRegistrationVehicle.otherName")}
                    />
                </div>
            </div>

            {_.get(data, 'titulaireCarteGrise') === 'autres' && (
                <div className="alert alert-danger mt-3 col-lg-8 offset-lg-2" role="alert">
                    {getTranslation("profil.holderRegistrationVehicle.alert")}
                </div>
            )}

            <button
                className={`btn btn-primary btn-arrow mt-4 ${
                    (!_.find(_.get(data, 'DemandeTarif[ListePersonnes]'), ['Souscripteur', true]) ||
                        _.get(data, 'titulaireCarteGrise') === 'autres' ||
                        !_.get(data, 'titulaireCarteGrise')) &&
                    'disabled'
                }`}
                onClick={() => nextQuestion()}
            >
                {getTranslation("continue")}
            </button>
        </Question>
    );
};

export default TitulaireCarteGrise;
